import { Input, Select } from "antd";
import countryCodes from "../data/country-phone-codes.json";
import Helper from "../Helper";

/**
 * Ülke kodlu telefon girişi — `antd-country-phone-input` paketinin yerine geçer.
 * O paket antd 4.x'e çakılıydı (peer: antd 4.x) ve v5 ile test edilmemişti; ayrıca çalışması için
 * kendi ConfigProvider'ına ülke listesi geçirmeyi zorunlu kılıyordu.
 *
 * Form değeri v4'teki ile BİREBİR aynı: { code: number, phone: string }
 * → PatientCreateEdit'teki phoneCode/phone ayrıştırma mantığı değişmedi.
 */
const options = countryCodes.map((c) => ({
    value: c.code,
    label: `${c.emoji} +${c.code}`,
    title: `${c.name} (+${c.code})`,
    search: `${c.name} ${c.short} ${c.code}`.toLowerCase(),
}));

/**
 * DİKKAT: addonBefore slot'u ülke kodu Select'ine ait — dışarıdan geçirilen bir addonBefore
 * sessizce ezilirdi (label hiç render edilmezdi). Bu yüzden burada tüketilip yok sayılıyor;
 * telefon label'ı çağıran tarafta input'un DIŞINDA <AddonBefore external /> ile veriliyor.
 */
export default function PhoneInput({ value = {}, onChange, disabled, inputProps, addonBefore: _ignoredAddon, ...rest })
{
    const emit = (next) => onChange?.({ ...value, ...next });

    return (
        <Input
            {...rest}
            {...inputProps}          /* eski paketin API'si: inputMode/type/onKeyDown/onPaste doğrudan input'a geçer */
            disabled={disabled}
            value={value.phone}
            onChange={(e) => emit({ phone: Helper.Phone.phoneFormat(e.target.value) })}
            addonBefore={
                <Select
                    showSearch
                    disabled={disabled}
                    value={value.code}
                    onChange={(code) => emit({ code })}
                    options={options}
                    optionFilterProp="search"
                    filterOption={(input, option) => option.search.includes(input.toLowerCase())}
                    style={{ width: 110 }}
                    popupMatchSelectWidth={280}
                />
            }
        />
    );
}
